window.onload = function () {
  const stickyAddToCart = document.querySelector('sticky-add-to-cart');
  if (stickyAddToCart) {
    stickyAddToCart.style.display = 'block';
  }
};

if (window.location.href.includes("shipping-insurance-skip-the-line")) {
  window.location.href = "/collections/ALL";  
}

const updateMainCart = async (cart) => {
  try {
    const sectionId = document.querySelector('#main-cart-items').getAttribute('data-id');

    const cartElement = document.querySelector('[data-cart]');
    const cartContent = cartElement.querySelector('[data-cart-content]');
    const cartTotals = cartElement.querySelector('[data-cart-total]');

    const cartLoading = `
    <div class="loading-overlay loading-overlay--custom">
      <div class="loading-overlay__spinner">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    </div>`;

    const loadingClass = 'is-loading';

    cartElement.classList.add(loadingClass);
    cartElement.insertAdjacentHTML('afterbegin', cartLoading);

    const response = await fetch(`/cart?section_id=${sectionId}`);
    const data = await response.text();

    const jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
    const parsedResponse = new DOMParser().parseFromString(jsPreventedData, 'text/html');

    cartElement.classList.remove(loadingClass);
    cartElement.querySelector('.loading-overlay').remove();

    if (cart.item_count > 0) {
      const contentCart = parsedResponse.querySelector('[data-cart-content] .cart').innerHTML;
      const subTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-subtotal').innerHTML;
      const grandTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-grandtotal').innerHTML;
      const savings = parsedResponse.querySelector('[data-cart-total] .cart-total-savings').innerHTML;

      cartContent.querySelector('.cart').innerHTML = contentCart;
      cartTotals.querySelector('.cart-total-subtotal').innerHTML = subTotal;
      cartTotals.querySelector('.cart-total-grandtotal').innerHTML = grandTotal;
      cartTotals.querySelector('.cart-total-savings').innerHTML = savings;

      const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
      if (calculatorShipping) {
        const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
        if (existingCalculator) {
          existingCalculator.replaceWith(calculatorShipping);
        }
      }

      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
        const changeEvent = new Event('change', { bubbles: true })
        freeShippingWrapper.dispatchEvent(changeEvent);
      })
    } else {
      const contentCart = parsedResponse.querySelector('#main-cart-items').innerHTML;
      const headerCart = parsedResponse.querySelector('.page-header').innerHTML;

      document.querySelector('#main-cart-items').innerHTML = contentCart;
      document.querySelector('.page-header').innerHTML = headerCart;

      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
        const changeEvent = new Event('change', { bubbles: true })
        freeShippingWrapper.dispatchEvent(changeEvent);
      })
    }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
};

async function updateSideCart(cart) {
    try {
      const cartElement = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
      const cartContent = cartElement.querySelector('.previewCartList');
      const cartTotals = cartElement.querySelector('.previewCartTotalsPrice');

      const cartLoading = `
      <div class="loading-overlay loading-overlay--custom">
        <div class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>`;

      const loadingClass = 'is-loading';

      cartElement.classList.add(loadingClass);
      cartElement.insertAdjacentHTML('afterbegin', cartLoading);

      const response = await fetch(`/cart?view=ajax_side_cart`);
      const data = await response.text();
      const parsedResponse = new DOMParser().parseFromString(data, 'text/html');

      cartElement.classList.remove(loadingClass);
      cartElement.querySelector('.loading-overlay').remove();      

      if (cart.item_count > 0) {        
        const contentCart = parsedResponse.querySelector('.previewCartList').innerHTML;        
        const contentTotals = parsedResponse.querySelector('.previewCartTotalsPrice').innerHTML;

        cartContent.innerHTML = contentCart;
        cartTotals.innerHTML = contentTotals;

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
        if (calculatorShipping) {
          const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
          if (existingCalculator) {
            existingCalculator.replaceWith(calculatorShipping);
          }
        }

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

//////////// OPTIMIZED CART UPSELL NEW //////////// 
// Enhanced visual feedback for cart count updates
function updateCartCountWithAnimation(newCount) {
  const cartCountElements = document.querySelectorAll('[data-cart-count]');
  cartCountElements.forEach(element => {
    element.classList.add('updating');
    element.textContent = newCount;
    
    setTimeout(() => {
      element.classList.remove('updating');
      element.classList.add('cart-count-updated');
      
      setTimeout(() => {
        element.classList.remove('cart-count-updated');
      }, 300);
    }, 200);
  });
}

// Optimized cart content update with visual feedback
function updateCartContentWithFeedback(cartElement, newContent) {
  if (!cartElement) return;
  
  const cartContent = cartElement.querySelector('.previewCartList');
  const cartTotals = cartElement.querySelector('.previewCartTotalsPrice');
  
  if (cartContent) {
    cartContent.classList.add('updating');
    setTimeout(() => {
      cartContent.innerHTML = newContent.querySelector('.previewCartList')?.innerHTML || '';
      cartContent.classList.remove('updating');
    }, 100);
  }
  
  if (cartTotals) {
    cartTotals.classList.add('updating');
    setTimeout(() => {
      cartTotals.innerHTML = newContent.querySelector('.previewCartTotalsPrice')?.innerHTML || '';
      cartTotals.classList.remove('updating');
    }, 100);
  }
}

// Enhanced updateSideCartOptimized function
async function updateSideCartOptimized(cart) {
  try {
    const cartElement = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!cartElement) return;

    // Show loading state
    const cartLoading = `
      <div class="loading-overlay loading-overlay--custom">
        <div class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>`;

    cartElement.classList.add('is-loading');
    cartElement.insertAdjacentHTML('afterbegin', cartLoading);

    // Fetch cart content in background
    const response = await fetch(`/cart?view=ajax_side_cart`);
    const data = await response.text();
    const parsedResponse = new DOMParser().parseFromString(data, 'text/html');

    // Remove loading state
    cartElement.classList.remove('is-loading');
    const loadingOverlay = cartElement.querySelector('.loading-overlay');
    if (loadingOverlay) loadingOverlay.remove();

    if (cart.item_count > 0) {
      // Update cart content with visual feedback
      updateCartContentWithFeedback(cartElement, parsedResponse);

      // Dispatch cart update event
      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

      // Handle calculator shipping
      const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
      if (calculatorShipping) {
        const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
        if (existingCalculator) {
          existingCalculator.replaceWith(calculatorShipping);
        }
      }

      // Handle free shipping updates
      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
        const changeEvent = new Event('change', { bubbles: true });
        freeShippingWrapper.dispatchEvent(changeEvent);
      });
    }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

// Enhanced main cart update function
async function updateMainCartOptimized(cart) {
  try {
    // Update cart count with animation
    updateCartCountWithAnimation(cart.item_count);

    // Dispatch cart update event
    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

    // Update cart content asynchronously
    const cartContainer = document.querySelector('.cart-items');
    if (cartContainer) {
      const response = await fetch('/cart?view=ajax_main_cart');
      const data = await response.text();
      const parsedResponse = new DOMParser().parseFromString(data, 'text/html');
      
      const newCartContent = parsedResponse.querySelector('.cart-items');
      if (newCartContent) {
        cartContainer.classList.add('updating');
        setTimeout(() => {
          cartContainer.innerHTML = newCartContent.innerHTML;
          cartContainer.classList.remove('updating');
        }, 100);
      }
    }
  } catch (error) {
    console.error('Error updating main cart:', error);
  }
}

// Enhanced add to cart event listener with better visual feedback
document.addEventListener('click', async (elm) => {
  let addToBagBtn = elm.target.closest('.add_to_bag');
  if (addToBagBtn) {
    // Prevent multiple clicks
    if (addToBagBtn.classList.contains('is-loading')) return;
    
    addToBagBtn.classList.add('is-loading');
    const originalText = addToBagBtn.textContent;
    addToBagBtn.innerHTML = '<div class="loader"><span style="display: none;">loading</span></div>';
    
    const productId = addToBagBtn.getAttribute('data-id');  

    try {
      // Optimized: Use Promise.all for parallel requests
      const [addResponse, cartResponse] = await Promise.all([
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: productId,
              quantity: 1
            }]
          })
        }),
        fetch('/cart.js')
      ]);

      console.log("cartResponse", cartResponse);

      const [addData, cartData] = await Promise.all([
        addResponse.json(),
        cartResponse.json()
              ]);

        // Update cart count with animation for instant feedback
        updateCartCountWithAnimation(cartData.item_count);

      // Show cart sidebar immediately
      document.body.classList.add('cart-sidebar-show');

      // Update cart content asynchronously (non-blocking)
      if (document.querySelector(".template-cart")) {
        updateMainCartOptimized(cartData);
      } else {
        updateSideCartOptimized(cartData);
      }

    } catch (error) {
      console.error('Error adding to cart:', error);
      // Show error message if needed
    } finally {
      // Restore button state
      addToBagBtn.classList.remove('is-loading');
      addToBagBtn.textContent = originalText;
    }
  }
});

// document.documentElement.addEventListener('cart:refresh', function () {
//   $('.ctm_cart_unsell').slick({
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     dots: false,
//     prevArrow: '<button type="button" class="slick-prev custom_slick_prev"><img src="https://cdn.shopify.com/s/files/1/2330/4667/files/left-arrow_2.png?v=1718100689" alt="Previous" /></button>',
//     nextArrow: '<button type="button" class="slick-next custom_slick_next"><img src="https://cdn.shopify.com/s/files/1/2330/4667/files/right-arrow_4_51a5f9c7-2b14-4040-b6ed-d168dd615242.png?v=1718099941" alt="Next" /></button>'
//   });
// });

document.addEventListener("DOMContentLoaded", function () {

  function Collectionhover() {
    if (window.matchMedia("(min-width:1px)").matches) {
      const hoverItems = document.querySelectorAll('.collection_hover_items');

      function removeAllActiveHover() {
        hoverItems.forEach(function (elem) {
          elem.classList.remove('active_hover');
        });
      }

      if (hoverItems.length > 0) {
        hoverItems[0].classList.add('active_hover');
      }

      hoverItems?.forEach(function (currElem) {
        currElem.addEventListener('mouseover', function () {
          removeAllActiveHover();
          currElem.classList.add('active_hover');
        });


      });
    }

    if (window.matchMedia("(max-width:1366px)").matches) {
      const items = document.querySelectorAll('.collection_hover_items');

      function handleClick(event) {
        const clickedItem = event.target.closest('.collection_hover_items');
        if (!clickedItem) return; // Exit if the click isn't on a relevant element
        items.forEach(item => item.classList.remove('hover_active'));
        clickedItem.classList.add('hover_active');
      }

      document.addEventListener('click', handleClick);
      if (items.length > 0) {
        items[0].classList.add('hover_active');
      }
    }

    if (window.matchMedia("(min-width:768px)").matches) {
      var innerElement = document.querySelector('.hover_active .coll_hover_text_inner');
      var parentElements = document.querySelectorAll('.collection_hover_items');

      if (innerElement) {
        function calculateTotalHeight(element) {
          var style = window.getComputedStyle(element);
          var margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
          var padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
          var totalHeight = element.offsetHeight + margin + padding;
          return totalHeight;
        }

        parentElements.forEach(function (parentElement) {
          var totalHeight = calculateTotalHeight(innerElement) + 60; // Adding 60 pixels

          if (totalHeight < 520) {
            totalHeight = 520;
          }

          parentElement.style.height = totalHeight + 'px';
          // console.log('Applied total height to .collection_hover_items:', totalHeight);
        });
      } else {
      }
    }

    function calculateTotalHeight(element) {
      var height = element.offsetHeight;
      var style = window.getComputedStyle(element);

      height += parseInt(style.marginTop) + parseInt(style.marginBottom);
      height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
      height += parseInt(style.borderTopWidth) + parseInt(style.borderBottomWidth);

      return height;
    }
  }

  Collectionhover();
  document.addEventListener('resize', Collectionhover)


  // =============== Video play pause ================
  document.querySelectorAll('.video_item')?.forEach(function (currVideo) {
    const videoElem = currVideo.querySelector('.ctm_vedio_pay_pause');
    const playButton = currVideo.querySelector('#video_play_button');
    const pauseButton = currVideo.querySelector('#video_pause_button');

    pauseButton.style.display = 'none';

    currVideo.querySelector('.ctm_video_buttons').addEventListener("click", function (event) {

      if (event.target.closest('#video_play_button') === playButton) {
        videoElem.play();
        playButton.style.display = 'none';
        pauseButton.style.display = 'inline-flex';
      } else if (event.target.closest('#video_pause_button') === pauseButton) {
        videoElem.pause();
        pauseButton.style.display = 'none';
        playButton.style.display = 'inline-flex';
      }
    });

    videoElem.addEventListener('ended', function () {
      playButton.style.display = 'inline-flex';
      pauseButton.style.display = 'none';
    });
  });


  //=========== Video section Initialize Swiper=======
   new Swiper('.swiper', {
    loop: true,
    grabCursor: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: (index, className) =>
        `<span class="${className}" data-index="${index}"></span>`
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    slidesPerView: 5,
    slidesPerGroup: 2,
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: "auto",
        spaceBetween: 10,
        centeredSlides: false,
        slidesPerGroup: 2
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 20,
        slidesPerGroup: 2
      },
      1240: {
        slidesPerView: 5,
        spaceBetween: 20,
        slidesPerGroup: 2
      }
    }
  });

new Swiper('.ingredient_swiper', {
    loop: false,
    grabCursor: true,
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      320: {
        slidesPerView: 1.25, // 👈 shows 1 full + part of 2nd
        spaceBetween: 10,
      },
      480: {
        slidesPerView:  1.25,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2.25,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 2.75,
        spaceBetween: 20
      },
      1240: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  });


  // document.querySelectorAll("[data-btn-addtocart]")?.forEach(function (curElm) {
  //   curElm.addEventListener("click", function (e) {
  //     e.preventDefault();  
  //     document.body.classList.add("cart-sidebar-show");
  //     const $cartDropdown = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
  //     const $cartLoading = '<div class="loading-overlay loading-overlay--custom">\
  //               <div class="loading-overlay__spinner">\
  //                   <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
  //                       <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
  //                   </svg>\
  //               </div>\
  //           </div>';
  //     const loadingClass = 'is-loading';

  //     $cartDropdown
  //       .addClass(loadingClass)
  //       .prepend($cartLoading);

  //     document.querySelector("[data-shipping-message]").innerHTML = "";
  //     document.querySelector("[data-cart-count]").innerHTML = "";
  //   })
  // })

});

document.addEventListener("DOMContentLoaded", function () {
  const nodes = document.querySelectorAll('.animating_node');
  let currentIndex = 0;

  function showNextNode() {
    nodes[currentIndex]?.classList.remove('active');
    currentIndex = (currentIndex + 1) % nodes.length;
    nodes[currentIndex]?.classList.add('active');
  }

  function startAnimation() {
    nodes[currentIndex]?.classList.add('active');
    setInterval(showNextNode, 2000);
  }

  startAnimation();

  // Custom price change according to Variant Change.
  let actualPriceInner = document.querySelector(".ctm_price_enable .custom_price")?.innerHTML;
  let comparePriceInner = document.querySelector(".ctm_price_enable .price__compare")?.innerHTML;
  document.querySelector(".productView-buttons")?.addEventListener("click", function (evt) {
    if (!document.querySelector(".subify-widget-box")) return;

    const activeCurrency = Shopify.currency.active ? Shopify.currency.active : "NZD";
    const noSellingPlanBox = evt.target.closest(".subify-choice-box-wrapper:nth-child(1)");
    
    if (noSellingPlanBox) {
      const newPrice = document.querySelector(".ctm_price_enable .custom_price");
      newPrice.innerHTML = actualPriceInner;
    } else {
      const subifyChoicePrice = document.querySelector('.subify-choice-box-wrapper.active .subify-choice-price')?.innerHTML;      
      // console.log(subifyChoicePrice, "subifyChoicePrice");      
      const newPrice = document.querySelector(".ctm_price_enable .custom_price");
      newPrice.innerHTML = `${comparePriceInner} ${subifyChoicePrice} ${activeCurrency}`;
    }
    setTimeout(updatePricePerGram, 100);
  });

  //  Video Section Play Pause Obserever 
  const handleVideoPlayback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  };

  const videoObserver = new IntersectionObserver(handleVideoPlayback, { threshold: 0.5 });

  document.querySelectorAll("video.text_with_video")?.forEach((video) => {
    videoObserver.observe(video);
  });

   setTimeout(updatePricePerGram, 300);
   let attempts = 0, maxAttempts = 50;
   const interval = setInterval(() => {
    const el = document.querySelector('.subify-widget-box .subify-choice-box-wrapper.active');
    if (el) {
      document.querySelector('.sticky_btn').style.display = 'block';
      el.click();
      clearInterval(interval);
      // Update price per gram after subify widget is ready
        setTimeout(updatePricePerGram, 200);
    }
    if (++attempts >= maxAttempts) clearInterval(interval);
     // Update price per gram even if subify widget doesn't load
        setTimeout(updatePricePerGram, 200);
  }, 200);

  // sticky product atc buttons

  ['.sticky_btn_atc_mobile', '.sticky_btn_atc_desktop'].forEach(selector => {
    document.querySelector(selector)?.addEventListener('click', () => {
      console.log('click occures')
      document.querySelector('.product-form__buttons button')?.click();
    });
  });
  
  function syncSubifySelection() {
    const widgetBox = document.querySelector('.subify-widget-box');
    if (widgetBox) {
      const activeOption = widgetBox.querySelector('.subify-choice-box-wrapper.active .subify-choice-wrapper span');
      const priceOption = widgetBox.querySelector('.subify-choice-box-wrapper.active .subify-choice-price-wrapper span');
      
      if (activeOption && priceOption) {
        const selectedText = activeOption.textContent.trim();
        const priceText = priceOption.textContent.trim();
        
        const select = document.getElementById('selected_purchase');
        if (select) {
          for (let option of select.options) {
            if (option.textContent.trim() === selectedText) {
              select.value = option.value;
              break;
            }
          }
        }

        const priceSpan = document.querySelector('.sticky_btn_atc_desktop span');
        if (priceSpan) {
          priceSpan.innerText = priceText;
        }
      }
    }
     // Update price per gram after selection sync
     setTimeout(updatePricePerGram, 100);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('.subify-widget-box')) {
      // Delay slightly in case DOM updates after click
      setTimeout(syncSubifySelection, 10);
    }
  });

  document.getElementById('selected_purchase')?.addEventListener('change', (e) => {
    const selectedText = e.target.value.trim();
    
    // Find all .subify-choice-box-wrapper elements
    const wrappers = document.querySelectorAll('.subify-choice-box-wrapper');
    
    wrappers.forEach(wrapper => {
      const labelSpan = wrapper.querySelector('.subify-choice-wrapper span');
      if (labelSpan && labelSpan.textContent.trim() === selectedText) {
        labelSpan.click(); // Trigger click on the span (or wrapper)
      }
    });
    // Update price per gram after selection change
  setTimeout(updatePricePerGram, 100);
  });

  function refresh_product_check() {
    const atcPrice = document.querySelector('.product-form__buttons .price__regular .price__last .price-item--regular')?.textContent.trim();
    if (!atcPrice) return;
    const priceSpan = document.querySelector('.sticky_btn_atc_desktop span');
    if (priceSpan) {
      priceSpan.innerText = atcPrice;
    }
  }

  refresh_product_check();
});

// product video slider

  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.product_video_slider');
    const popupInner = document.querySelector('.popup_product_video_inner');
    const popupContainer = document.querySelector('.popup_product_container');
    const closeButton = document.querySelector('.remove_popup_product_video');
    const closeButtonOverlay = document.querySelector('.popup_product_video_overlay');

    // Show the popup
    function showPopup() {
      if (popupContainer) {
        popupContainer.style.display = 'block';
      }
    }

    // Hide popup on 'X' click
    if (closeButton && popupContainer) {
      closeButton.addEventListener('click', function () {
        popupContainer.style.display = 'none';
        popupInner.innerHTML = '';
      });
      closeButtonOverlay.addEventListener('click', function () {
        popupContainer.style.display = 'none';
        popupInner.innerHTML = '';
      });
    }

    // Handle video click to open popup
    if (slider && popupInner) {
      slider.addEventListener('click', function (e) {
        const clickedItem = e.target.closest('.product_video_item');
        if (!clickedItem) return;

        const clickedVideo = clickedItem.querySelector('video');
        if (!clickedVideo) return;

        const isMuted = document.querySelector('.popup_product_videos .vdo_unmute_btn')?.style.display == "none";

        const clonedVideo = clickedVideo.cloneNode(true);
        clonedVideo.controls = false;
        clonedVideo.autoplay = true;
        clonedVideo.muted = isMuted;

        popupInner.innerHTML = '';
        popupInner.appendChild(clonedVideo);

        showPopup();
      });
    }

    // Optional: make showPopup globally callable
    window.showPopupProductVideo = showPopup;

    $('.product_video_slider').slick({
       infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: false,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }
        ]
      });
  });

document.addEventListener("click", function (e) {
  if (e.target.closest(".popup_product_videos .vdo_unmute_btn")) {
      const video = document.querySelector(".popup_product_videos .product_ctm_vedio_pay_pause");
      if (video) video.muted = true;
      e.target.closest(".popup_product_videos .vdo_unmute_btn").style.display = "none";
      document.querySelector(".popup_product_videos .vdo_mute_btn").style.display = "block";
  }

  if (e.target.closest(".popup_product_videos .vdo_mute_btn")) {
      const video = document.querySelector(".popup_product_videos .product_ctm_vedio_pay_pause");
      if (video) video.muted = false;
      e.target.closest(".popup_product_videos .vdo_mute_btn").style.display = "none";
      document.querySelector(".popup_product_videos .vdo_unmute_btn").style.display = "block";
  }
});


function toggleStickyBit() {
  const formButtons = document.querySelector('.multiColumn_conn');
  const sticky = document.querySelector('.sticky_bit');

  if (formButtons && sticky) {
    const rect = formButtons.getBoundingClientRect();
    const offsetTop = rect.top + window.scrollY;

    if (window.scrollY >= offsetTop) {
      sticky.classList.add('visible');
    } else {
      sticky.classList.remove('visible');
    }
  }
}

// function toggleStickyBit() {
//   const sticky = document.querySelector('.sticky_bit');

//   if (sticky) {

//     if (window.scrollY >= 1600) {
//       sticky.classList.add('visible');
//     } else {
//       sticky.classList.remove('visible');
//     }
//   }
// }

window.addEventListener('scroll', toggleStickyBit);
window.addEventListener('load', toggleStickyBit);

document.addEventListener('click', e => {
  if (e.target.matches('.subify-choice-box-wrapper')) {
    e.target.querySelector('div')?.click();
    // Update price per gram after selection change
    setTimeout(updatePricePerGram, 100);
  }
});


function updatePricePerGram() {
  const connectedProducts = document.querySelectorAll('.meta_connected_prd');
  const isSubscribeSelected = document.querySelector('.subify-choice-box-wrapper.active .subify-choice-wrapper span')?.textContent.trim() === 'Subscribe & Save 20%';
  
  connectedProducts.forEach(product => {
    const priceElement = product.querySelector('.prod_var_price');
    const pricePerGramElement = product.querySelector('.prod_price_gram');
    const actualPriceElement = product.querySelector('.prod_ac_price');
    
    if (priceElement && pricePerGramElement && actualPriceElement) {
      const grams = parseInt(priceElement.textContent.trim());
      const actualPrice = parseInt(actualPriceElement.textContent.trim()) / 100;
      
      let finalPrice;
      if (isSubscribeSelected) {
        // Apply 20% discount for subscribe
        finalPrice = actualPrice * 0.8;
      } else {
        // Use original price for one-time purchase
        finalPrice = actualPrice;
      }
      
      const pricePerGram = (finalPrice / grams).toFixed(2);
      pricePerGramElement.textContent = `$${pricePerGram}/g`;
    }
  });
}

// Make function globally available
window.updatePricePerGram = updatePricePerGram;






